<template>
  <section class="download" id="download">
    <div class="container">

      <div class="section-intro">
        <h4>下载安装，立即体验</h4>
      </div>

      <!-- 下载卡片 -->
      <div class="download-card">
        <div class="download-left">
          <div class="product-info">
            <div class="product-logo">
              <img src="@/assets/logo.png" alt="KiloSeek Logo">
            </div>
            <div class="product-text">
              <h3>千寻搜图</h3>
              <p>本地 AI 智能搜图 · 人脸 + 图文双引擎</p>
            </div>
          </div>

          <div class="requirements">
            <div class="req-item">
              <span class="req-icon">🖥️</span>
              <span><strong>系统：</strong>Win10/Win11</span>
            </div>
            <div class="req-item">
              <span class="req-icon">⚙️</span>
              <span><strong>CPU：</strong>Intel 酷睿 I3/I5/I7/Ultra5/Ultra7 及以上</span>
            </div>
          </div>
        </div>
        <div class="download-right">
          <a href="https://pan.quark.cn/s/5817af286fd9#/list/share" target="_blank" class="btn-download-main">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            夸克网盘(推荐)
          </a>
          <a href="https://pan.baidu.com/s/5pVyYCYYoedfOENwxp4UEXw?#list/path=%2F%E5%8D%83%E5%AF%BB%E6%90%9C%E5%9B%BE" target="_blank" class="btn-download-sub">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            百度网盘
          </a>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'SiteDownload',
  data() {
    return {
      quickSteps: [
        {
          title: '下载安装',
          desc: '访问 kiloseek.cn 下载并安装软件'
        },
        {
          title: '管理员运行',
          desc: '右键"以管理员身份运行"软件'
        },
        {
          title: '设置图库',
          desc: '指定图片文件夹，等待分析完成'
        },
        {
          title: '开始搜图',
          desc: '选择入口和方式，立即搜索'
        }
      ]
    }
  },
  methods: {
    scrollToSection(id) {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.download {
  padding: 30px 0;
  background: linear-gradient(180deg, #f0f7ff 0%, #fff 100%);
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 32px;
}

.section-intro {
  text-align: center;
  margin-bottom: 28px;
}

.section-tag {
  display: inline-block;
  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  color: #2563eb;
  font-size: 13px;
  font-weight: 700;
  padding: 6px 16px;
  border-radius: 20px;
  margin-bottom: 16px;
  letter-spacing: 1px;
  text-transform: uppercase;
  border: 1px solid rgba(37, 99, 235, 0.15);
}

.section-intro h2 {
  font-size: 34px;
  font-weight: 800;
  color: #1a202c;
  margin: 0 0 14px;
}

.section-intro p {
  font-size: 17px;
  color: #718096;
  margin: 0;
}

/* 下载卡片 */
.download-card {
  background: #fff;
  border-radius: 24px;
  padding: 40px;
  display: flex;
  gap: 48px;
  align-items: center;
  border: 1.5px solid #e2e8f0;
  box-shadow: 0 8px 32px rgba(0,0,0,0.06);
  margin-bottom: 28px;
}

.download-left {
  flex: 1;
}

.product-info {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 24px;
}

.product-logo img {
  height: 52px;
  width: auto;
}

.product-text h3 {
  font-size: 20px;
  font-weight: 800;
  color: #1a202c;
  margin: 0 0 4px;
}

.product-text p {
  font-size: 13px;
  color: #718096;
  margin: 0;
}

.download-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
}

.badge {
  background: #f0f7ff;
  color: #2563eb;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid rgba(37, 99, 235, 0.15);
}

.requirements {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.req-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #4a5568;
}

.req-icon {
  font-size: 14px;
}

.download-right {
  text-align: center;
  flex-shrink: 0;
}

.download-version {
  font-size: 13px;
  color: #718096;
  margin-bottom: 16px;
  font-weight: 500;
}

.btn-download-main {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: linear-gradient(135deg, #4e8cff, #6ec1e4);
  color: #fff;
  font-size: 17px;
  font-weight: 700;
  padding: 16px 40px;
  border-radius: 14px;
  text-decoration: none;
  box-shadow: 0 8px 28px rgba(78, 140, 255, 0.4);
  transition: all 0.3s ease;
  margin-bottom: 12px;
}

.btn-download-main:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 36px rgba(78, 140, 255, 0.5);
}

.btn-download-sub {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--primary);
  font-size: 14px;
  font-weight: 600;
  padding: 12px 28px;
  border-radius: 14px;
  text-decoration: none;
  border: 2px solid rgba(78, 140, 255, 0.35);
  transition: all 0.3s ease;
  margin-bottom: 12px;
}

.btn-download-sub:hover {
  background: rgba(78, 140, 255, 0.06);
  border-color: var(--primary);
}

.download-tip {
  font-size: 12px;
  color: #a0aec0;
  margin: 0;
}

/* 活动卡片 */
.activity-card {
  background: linear-gradient(135deg, #fff7ed, #ffedd5);
  border: 1.5px solid #fed7aa;
  border-radius: 18px;
  padding: 24px 28px;
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 48px;
}

.activity-icon {
  font-size: 32px;
  flex-shrink: 0;
}

.activity-content {
  flex: 1;
}

.activity-content h4 {
  font-size: 16px;
  font-weight: 700;
  color: #92400e;
  margin: 0 0 4px;
}

.activity-content p {
  font-size: 13px;
  color: #b45309;
  margin: 0;
}

.activity-btn {
  flex-shrink: 0;
  padding: 10px 22px;
  background: #f97316;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.25s ease;
  white-space: nowrap;
}

.activity-btn:hover {
  background: #ea580c;
  transform: translateY(-1px);
}

/* 快速入门 */
.quick-start h3 {
  font-size: 20px;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 24px;
  text-align: center;
}

.quick-steps {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.quick-step {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px 16px;
  text-align: center;
}

.qs-num {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #4e8cff, #6ec1e4);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 800;
  margin: 0 auto 12px;
}

.quick-step h4 {
  font-size: 14px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 6px;
}

.quick-step p {
  font-size: 12px;
  color: #718096;
  margin: 0;
  line-height: 1.5;
}

.quick-cta {
  text-align: center;
}

.btn-tutorial {
  display: inline-flex;
  align-items: center;
  color: var(--primary);
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  gap: 4px;
  transition: color 0.2s;
}

.btn-tutorial:hover {
  color: #2563eb;
}

@media (max-width: 768px) {
  .download-card { flex-direction: column; gap: 28px; padding: 28px 24px; }
  .quick-steps { grid-template-columns: repeat(2, 1fr); }
  .activity-card { flex-direction: column; text-align: center; }
  .section-intro h2 { font-size: 26px; }
}

@media (max-width: 480px) {
  .container { padding: 0 16px; }
  .quick-steps { grid-template-columns: 1fr; }
}
</style>
